export enum TermsOriginEnum {
	TELEHEALTH = 'TELECONSULTA',
	EMERGENCY_TELEHEALTH = 'Pronto Atendimento Digital',
}
